import React from 'react';

export default function FavoritesSkeleton({ count = 8 }) {
    const items = Array.from({ length: count });
    return (
        <div className="w-full">
            <div className="grid gap-6 grid-cols-1 lg:h-[calc(100vh-10rem)] overflow-y-auto pb-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 animate-pulse">
                {items.map((_, i) => (
                    <div
                        key={i}
                        className="bg-white rounded-xl border animate-pulse border-gray-300 shadow-sm overflow-hidden p-2 md:p-3 flex flex-col max-sm:flex-row h-[170px] sm:h-[400px] md:h-[400px] lg:h-[400px] w-full max-sm:w-full"
                    >
                        {/* image container mirrors AdsCart */}
                        <div className="relative w-full sm:w-full max-sm:w-28 max-sm:h-auto flex-shrink-0 overflow-hidden sm:h-[200px] max-sm:order-2">
                            <div className="w-full bg-gray-300 sm:rounded-lg max-sm:rounded-none max-sm:rounded-r-lg object-cover h-44 mt-1 sm:mb-4 max-sm:h-36" />

                            <div className="absolute bottom-3 sm:bottom-7 left-2 flex items-center gap-2 bg-black bg-opacity-50 rounded-full px-2 py-1">
                                <div className="h-3 w-12 bg-gray-300 rounded" />
                                <div className="h-4 w-4 bg-gray-300 rounded-full" />
                            </div>
                        </div>

                        {/* content column mirrors AdsCart */}
                        <div className="p-3 flex flex-col gap-2 flex-1 max-sm:order-1">
                            <div className="h-5 w-3/4 bg-gray-300 rounded mb-2" />
                            <div className="h-4 w-full bg-gray-300 rounded mb-2" />

                            <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row gap-2 items-start sm:items-center justify-between mt-auto pt-2">
                                <div className="h-6 w-28 bg-gray-300 rounded-lg" />
                                <div className="h-4 w-32 bg-gray-300 rounded" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
